import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '软件产品丨消安联防一体化平台'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '软件产品丨智慧营区一体化'
              }
            },
            {
              path: '/software/company',
              name: 'software',
              component: resolve => require(['@/view/software/Software_Company'], resolve),
              meta: {
                title: '软件产品丨停车场智慧缴费系统'
              }
            },
            {
              path: '/software/hospital',
              name: 'software',
              component: resolve => require(['@/view/software/Software_Hospital'], resolve),
              meta: {
                title: '软件产品丨医院排队系统'
              }
            },
            {
              path: '/software/dian',
              name: 'software',
              component: resolve => require(['@/view/software/Software_dian'], resolve),
              meta: {
                title: '软件产品丨电气火灾监控系统'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '企业服务'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          },

        },
        {
          path: '/companyintroduction/honour',
          name: 'companyHonour',
          component: () => import('@/view/CompanyIntroduction/CompanyHonour.vue'),
          meta: {
            title: '公司介绍丨荣誉资质'
          }
        },
        {
          path: '/companyintroduction/culture',
          name: 'companyCulture',
          component: () => import('@/view/CompanyIntroduction/CompanyCulture.vue'),
          meta: {
            title: '公司介绍丨企业文化'
          }
        },
        {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'], resolve),
          meta: {
            title: '企业服务'
          }
        },
        {
          path: '/service/ISI',
          name: 'ServiceSection-ISI',
          component: () => import('@/view/Service/ServiceSection-ISI.vue'),
          meta: {
            title: '企业服务 丨智能化系统集成'
          }
        },
        {
          path: '/service/CA',
          name: 'ServiceSection-CA',
          component: () => import('@/view/Service/ServiceSection-CA.vue'),
          meta: {
            title: '企业服务 丨软件定制化开发'
          }
        },
        {
          path: '/service/MS',
          name: 'ServiceSection-MS',
          component: () => import('@/view/Service/ServiceSection-MS.vue'),
          meta: {
            title: '企业服务 丨 维保服务'
          }
        },
        {
          path: '/service/DGA',
          name: 'ServiceSection-DGA',
          component: () => import('@/view/Service/ServiceSection-DGA.vue'),
          meta: {
            title: '企业服务 丨 数字政务'
          }
        },
        {
          path: '/newDetail',
          name: 'newDetail',
          component: () => import('@/view/news/newDetail.vue'),
          meta: {
            title: '新闻中心'
          }
        },
        {
          path: '/admin',
          name: 'admin',
          component: () => import('@/view/admin/adminCompany.vue'),
          meta: {
            title: '公司后台'
          }
        },
        {
          path: '/admin/honour',
          name: 'adminHounr',
          component: () => import('@/view/admin/components/adminHonur.vue'),
          meta: {
            title: '公司后台 | 公司资质'
          }
        },

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js